export const currencyConverter = (amount, withoutRp) => {

   if(amount == undefined ) {
     return 'Rp0';
   } else {
     const _amount = amount < 0 || amount == null ? 0 : amount;
     return `${withoutRp ? '' : 'Rp'}${String(_amount).replace(
       /\B(?=(\d{3})+(?!\d))/g,
       '.',
     )}`;
   }
   
 };